<template>
  <div
    class="container"
    :style="{backgroundImage:'url('+back_images+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}"
  >
    <div class="login-container">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <div class="title-container">
          <h3 class="title">系统<br><br>登录</h3>
        </div>
        <el-form-item prop="username">
          <el-input
            ref="username"
            v-model="loginForm.username"
            size="medium"
            placeholder="请输入用户名"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            ref="password"
            v-model="loginForm.password"
            size="medium"
            placeholder="请输入密码"
            name="password"
            type="password"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          style="width:80%;margin-top: 5%"
          @click.native.prevent="handleLogin"
        >登录
        </el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import { validUsername } from '@/utils/validate'

export default {
  name: 'Login',
  data: function() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('用户名不能为空'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入正确密码'))
      } else {
        callback()
      }
    }
    return {
      back_images: require('@/assets/bac.jpg'),
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$store.dispatch('user/customerLogin', this.loginForm).then(() => {
        this.$router.push({ path: this.redirect || '/customer/table' })
      })
    }
  }
}
</script>
<style>
    .el-input--medium {
        width: 80%;
        margin-top: 3%;
    }

    .el-form-item--small .el-form-item__error {
        margin-top: 2px;
    }

    .el-form-item__error {
        margin: 0 10% 0 12%;
        width: 75%;
        font-size: 1rem;
        color: brown;
    }
</style>
<style lang="scss" scoped>
    $bg: #2d3a4b;
    $dark_gray: #889aa4;
    $light_gray: #303133;
    .container {
        pointer-events: none;
        margin: 0;
        padding: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: center;
        vertical-align: middle;

        .login-container {

            border: 1px rgb(217, 236, 255) solid;
            /*设置元素绝对定位*/
            position: absolute;
            pointer-events:auto;
            /*top 50%*/
            top: 55%;
            /*left 50%*/
            left: 50%; /*css3   transform 实现*/
            background: rgba(217, 236, 255, 0.5);
            transform: translate(-50%, -60%);
            width: 80%;
            max-width: 25rem;
            height: 60%;
            min-height: 25rem;
            border-radius: 8px;
        }

        .title-container {
            position: relative;
            padding-top: 3%;
            margin-top: 15%;

            .title {
                font-size: 26px;
                color: $light_gray;
                margin: 0px auto 40px auto;
                text-align: center;
                font-weight: bold;
            }

        }

    }
</style>
